// Overview content for the Study Guide index page. Mirrors the section
// headings used in the full domain guides — expand subjectMatters with real
// sub-topic breakdowns as you add content, following the same
// {heading, items} shape shown below.

export const examWeighting = [
  { subject: 'Craft and Structure', weight: 15, questions: '~13-15' },
  { subject: 'Information and Ideas', weight: 15, questions: '~12-14' },
  { subject: 'Standard English Conventions', weight: 15, questions: '~11-15' },
  { subject: 'Expression of Ideas', weight: 10, questions: '~8-12' },
  { subject: 'Algebra', weight: 15, questions: '~13-15' },
  { subject: 'Advanced Math', weight: 15, questions: '~13-15' },
  { subject: 'Problem-Solving and Data Analysis', weight: 8, questions: '~5-7' },
  { subject: 'Geometry and Trigonometry', weight: 7, questions: '~5-7' },
];

export const sourceMaterials = {
  general:
    'The digital SAT is developed and administered by the College Board. It has two sections — Reading and ' +
    'Writing, and Math — each split into two adaptive modules, for 98 scored questions total in about 134 minutes.',
  official: [
    'College Board Bluebook practice tests',
    'College Board Official SAT Practice on Khan Academy',
    'The College Board\'s published SAT Suite Question Bank',
  ],
};

export const examStructure = [
  '98 scored questions across two sections (Reading and Writing, then Math), roughly 134 minutes total.',
  'Each section has two modules; the difficulty of the second module adapts based on performance on the first.',
  'Scored on a 400–1600 scale (200–800 per section) — there is no pass/fail cutoff.',
];

export const backgroundNote =
  'Most US colleges accept SAT scores as part of undergraduate admissions, and many scholarship programs use ' +
  'score thresholds directly. There is no penalty for guessing, so a fully blank answer is always worse than a guess.';

export const subjectMatters = [
  {
    id: 'reading-and-writing',
    title: 'Reading and Writing',
    weight: '55% of the exam (54 of 98 questions)',
    components: [
      {
        heading: 'Craft and Structure',
        items: [
          'Words in context — determining the meaning of a word or phrase from surrounding context',
          'Text structure and purpose — how a passage or paragraph is organized, and why',
          'Cross-text connections — comparing the ideas or approaches in two related passages',
        ],
      },
      {
        heading: 'Information and Ideas',
        items: [
          'Central ideas and details — identifying a passage\'s main point vs. its supporting details',
          'Command of evidence (textual) — choosing the quotation that best supports a claim',
          'Command of evidence (quantitative) — reading data from a table or graph to support a claim',
          'Inferences — drawing a logical conclusion the passage implies but doesn\'t state directly',
        ],
      },
      {
        heading: 'Standard English Conventions',
        items: [
          'Boundaries — joining and punctuating clauses correctly (no comma splices or run-ons)',
          'Form, structure, and sense — agreement, verb tense, modifier placement, and parallel structure',
        ],
      },
      {
        heading: 'Expression of Ideas',
        items: [
          'Rhetorical synthesis — choosing the sentence that best accomplishes a stated goal',
          'Transitions — choosing the word or phrase that signals the correct logical relationship',
        ],
      },
    ],
  },
  {
    id: 'math',
    title: 'Math',
    weight: '45% of the exam (44 of 98 questions)',
    components: [
      {
        heading: 'Algebra',
        items: [
          'Linear equations and inequalities in one variable',
          'Linear equations and functions in two variables',
          'Systems of two linear equations',
          'Linear inequalities and systems of inequalities in two variables',
        ],
      },
      {
        heading: 'Advanced Math',
        items: [
          'Equivalent expressions and factoring',
          'Nonlinear equations in one variable and systems',
          'Nonlinear functions, including quadratics and exponentials',
        ],
      },
      {
        heading: 'Problem-Solving and Data Analysis',
        items: [
          'Ratios, rates, proportions, and units',
          'Percentages',
          'One- and two-variable data: distributions, statistics, and scatterplots',
          'Probability, sample statistics, and evaluating study design',
        ],
      },
      {
        heading: 'Geometry and Trigonometry',
        items: [
          'Area, volume, and angle relationships',
          'Triangles and trigonometric ratios',
          'Circles',
        ],
      },
    ],
  },
];
